import React from 'react';
import PropTypes from 'prop-types';

import withStyles from "@material-ui/core/styles/withStyles";
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  spinner: {
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& div': {
      width: 10,
      height: 10,
      backgroundColor: grey[50],
      borderRadius: '100%',
      display: 'inline-block',
      animation: '$bouncedelay 1.4s infinite ease-in-out both'
    },
  },

  bounce1: {
    animationDelay: '-0.32s !important'
  },

  bounce2: {
    animationDelay: '-0.16s !important'
  },

  '@keyframes bouncedelay': {
    '0%, 80%, 100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1.0)'
    }
  }
});

const OSSLoadingIndicator = ({ classes }) => {
  return (
    <div className={classes.spinner}>
      <div className={classes.bounce1}></div>
      <div className={classes.bounce2}></div>
      <div className={classes.bounce3}></div>
    </div>
  )
}

OSSLoadingIndicator.propTypes = {
  classes: PropTypes.object.isRequired
};
OSSLoadingIndicator.defaultProps = {};

export default withStyles(styles)(OSSLoadingIndicator);

